export const Categories = [
  "All",
  "Equity",
  "Fixed Income",
  "Hybrid",
  "Fund of Fund",
  "Index",
  // "ETF",
];
export const Type = [
  "All",
  "Growth",
  "Payout",
  "Reinvestment",
  "IDCW - Annual",
  "IDCW - Fortnightly",
  "IDCW - Halfyearly",
];
export const data = [
  {
    id: 1,
    name: "All",
  },
  {
    id: 2,
    name: "NFO",
  },
  {
    id: 3,
    name: "Equity",
  },
  {
    id: 4,
    name: "Debt",
  },
  {
    id: 5,
    name: "Hybrid",
  },
  {
    id: 6,
    name: "FOF",
  },
  {
    id: 7,
    name: "Index Funds",
  },
];
export enum OTP_INTERVAL {
  FIRST_TIME = 30,
  SECOND_TIME = 60,
}
// constants public exports
export { };

export enum INVESTMENT_TYPES {
  LUMPSUM = "Lumpsum",
  SIP = "SIP",
  DAILY_SIP = "Daily SIP",
}
export const INVESTMENT_MODES: Record<string, string> = {
  direct: "Direct",
  regular: "Regular",
};

export const INVESTMENT_ACCOUNT_TYPES: Record<string, string> = {
  individual: "Individual",
  //TODO : uncomment after prod release
  // minor: "Minor",
  jointHolder: "Joint Holder",
};
export const INVESTMENT_DURATION_TYPES: Record<string, string> = {
  daily: "Daily",
  weekly: "Weekly",
  monthly: "Monthly",
  quarterly: "Quarterly",
  halfyearly: "Halfyearly",
  yearly: "Yearly",
};
export const ACCOUNT_HOLDER_TYPES: Record<string, string> = {
  individual: "Individual",
  joint: "Minor",
};

export function removeInvescoIndia(str: string) {
  const regex = /^(Invesco India|Invesco)\s*-?\s*/i;
  return str?.replace(regex, "").trim();
}
export const TOAST_DURATION = 7500;

export const INCAPACITATION_TITLE =
  " I/We hereby request that the name/details of my/our nominee should be included in the account statement provided to me/us by the Asset Management Company (AMC) as mentioned above.";

export const INCAPACITATION_NOMINEE_INFO =
  "(I hereby authorize this nominee to operate my account on my behalf, in case of my incapacitation. He/She is authorized to encash my assets up to...)";

export const FUND_CODE = "120";

export enum INCAPACITATION {
  PERCENTAGE = "Percentage",
  AMOUNT = "Amount",
}

export enum NOMINEE_ID_TYPE {
  PAN = "PAN",
  AADHAAR = "Aadhaar",
  DRIVING_LICENCE = "Driving Licence",
  PASSPORT = "Passport",
}

export const nomineeIdTypes = [
  { label: "PAN", value: NOMINEE_ID_TYPE.PAN },
  { label: "Aadhaar", value: NOMINEE_ID_TYPE.AADHAAR },
  { label: "Driving Licence", value: NOMINEE_ID_TYPE.DRIVING_LICENCE },
  { label: "Passport Number", value: NOMINEE_ID_TYPE.PASSPORT },
];

export const MAX_NOMINEE_ALLOWED_INFO = "You can add upto 3 Nominees.";

// Shown under the Regular plan / broker (ARN) section on both web and mobile so
// investors understand the cost trade-off of choosing a Regular plan.
export const REGULAR_PLAN_EXPENSE_RATIO_INFO =
  "Regular Plans generally have a higher expense ratio than direct plans due to distributor commission";

export const NOMINEE_BENEFITS = [
  {
    icon: "TOOnFRO",
    label: "Ensures smooth transfer of investments in case of unforeseen events",
  },
  {
    icon: "Frame",
    label: "Easy and quick process to assign a nominee",
  },
  {
    icon: "Group",
    label: "You can update or change nominees anytime",
  },
  {
    icon: "Order",
    label: "Avoids legal complications for your family or legal heirs",
  },
  {
    icon: "HeartTick",
    label: "Gives you peace of mind knowing your assets are protected",
  },
];

export enum PAYMENT_MODE {
  NET_BANKING = "Net Banking",
  UPI = "UPI",
  ENACH = "eNACH",
  UPI_MANDATES = "UPI Mandates",
  NEFT_RTGS = "NEFT/RTGS",
}

export enum FREQUENCY_VALUE {
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
  QUARTERLY = "QUARTERLY",
  YEARLY = "YEARLY",
}

export enum SIP_TYPE_VALUE {
  NUMBER_OF_INSTALLMENTS = "No. of Installments",
  NUMBER_OF_YEARS = "No. of Years",
  UNTIL_CANCELLED = "Until Cancelled",
}

export enum AMOUNT_UNIT_VALUE {
  AMOUNT = "Amount",
  UNITS = "Units",
}
export const MINIMUM_ARN_CODE_LENGTH = 3;
export const MINIMUM_EUIN_CODE_LENGTH = 6;

export const OTHER_FUNDS: Record<any, string[]> = {
  Equity: [
    "Invesco India Business Cycle Fund",
    "Invesco India Contra Fund",
    "Invesco India ELSS Tax Saver Fund",
  ],
  "Fixed Income": ["Debt Fund 1", "Debt Fund 2"],
  "Fund of Funds": ["FoF 1", "FoF 2"],
  Exchange: ["ETF 1", "ETF 2"],
};

export const ACCOUNT_TYPE = {
  CURRENT: "Current",
  SAVINGS: "Saving",
  NRI: "NRI",
  NRO: "NRO",
};

// Investor category codes and their human-readable equivalents. The backend
// encodes categories as numeric strings ("11" resident, "21" NRI-repatriable,
// "22" NRI-non-repatriable) but some flows carry the label form, so validation
// gating must accept both.
export const INVESTOR_CATEGORY = {
  RESIDENT_INDIAN: "11",
  NRI_REPATRIABLE: "21",
  NRI_NON_REPATRIABLE: "22",
} as const;

// Categories that require NRI address details (both code and label forms).
export const NRI_CATEGORY_VALUES = [
  INVESTOR_CATEGORY.NRI_REPATRIABLE,
  INVESTOR_CATEGORY.NRI_NON_REPATRIABLE,
  "NRI-REPATRIABLE",
  "NRI-NON-REPATRIABLE",
] as const;

export const CORPORATE_OUR_FUNDS_URL =
  "https://uat-newcorporate.invescomutualfund.com/our-funds?collections=";

// KFintech FATCA/TIN self-update portal. Shared so web + mobile open the same
// destination from the TIN-update prompt and the FATCA modification flows.
export const KFINTECH_FATCA_TIN_UPDATE_URL = "https://mfs.kfintech.com/fatcaupdate";

export const SKIPPED_TRTYPES = ["LTIN", "LTIA", "STPA", "SWIA", "SWIN"];

export const ETF_SCHEME_CODES = ["BX", "SX"]; // for demat sections

export * from "./unclaimedRedemption";

// Accepted input formats for parsing API/transaction date strings with dayjs
// customParseFormat. Centralized so all screens parse dates consistently.
export const DATE_PARSE_FORMATS = [
  "DD/MM/YYYY",
  "D/M/YYYY",
  "DD/M/YYYY",
  "D/MM/YYYY",
  "YYYY-MM-DD",
  "DD MMM, YYYY",
];
